import React, { useState } from 'react';

import CardInterior from './CardInterior';
import { LinearProgress, Stack } from '@mui/material';
import CardDownloadButton from './CardDownloadButton';
import { getFileExtension } from 'utils/GetFileExtension';

export default function CardInfo({ item }) {
  const [isDataLoading, setIsDataLoading] = useState(false);

  const fileExtension = getFileExtension(item?.NameFile);

  return (
    <>
      <Stack>
        <CardInterior item={item}>
          <Stack direction="row-reverse" gap=".5em">
            <CardDownloadButton
              itemId={item.Id}
              setIsDataLoading={setIsDataLoading}
            />
            {fileExtension === 'pdf' ? (
              <CardDownloadButton
                itemId={item.Id}
                setIsDataLoading={setIsDataLoading}
                isPreviewFile={true}
              />
            ) : (
              <></>
            )}
          </Stack>

          {isDataLoading ? <LinearProgress /> : <></>}
        </CardInterior>
      </Stack>
    </>
  );
}
